import { Route, Switch } from 'react-router-dom'
import './Global.css'
import AppProvider from './hooks'
import GlobalStyles from './styles/global'
import MeuPerfil from './pages/MeuPerfil'
import MeusEnderecos from './pages/MeusEnderecos'
import Negociacoes from './pages/Negociacoes'
import Cotacoes from './pages/Cotacoes'
import Gimplus from './pages/Gimplus'
import VendasPromovidas from './pages/VendasPromovidas'
import RedefinirSenha from './pages/RedefinirSenha'
import Login from './pages/Auth/Login'
import Logout from './pages/Auth/Logout'
import Home from './pages/Home'
import Impressao from './pages/Impresao'
import MeusCartoes from './pages/MeusCartoes'
import MeusPedidos from './pages/MeusPedidos'
import MeusPedidosItem from './pages/MeusPedidosItem'
import Pedidos from './pages/Pedidos'
import Finalizado from './pages/Finalizado'
import Erro404 from './pages/Erro404'
import PrivateRoute from './routes'
import NegociacoesItem from './pages/NegociacoesItem'
import CotacoesItem from './pages/CotacoesItem'
import TagManager from 'react-gtm-module'
import { useEffect } from 'react'

function App() {
  useEffect(() => {
    // if (
    //   process.env.REACT_APP_API_CLIENTE === 'https://api.gimba.com.br/clientes/'
    // )
    TagManager.initialize({
      gtmId: 'GTM-5QKH8R'
    })
  }, [])
  return (
    <AppProvider>
      <Switch>
        <Route exact path="/auth" component={Login} />
        <Route exact path="/logout" component={Logout} />
        <Route exact path="/" component={Home} />
        <Route exact path="/meu-perfil" component={MeuPerfil} />
        <Route exact path="/redefinir-senha" component={RedefinirSenha} />

        <PrivateRoute exact path="/meus-pedidos" component={MeusPedidos} />
        <PrivateRoute
          path="/meus-pedidos/:idPedido"
          component={MeusPedidosItem}
        />

        {/* <PrivateRoute exact path="/alterar-senha" component={AlterarSenha} /> */}
        <PrivateRoute exact path="/negociacoes" component={Negociacoes} />
        <PrivateRoute
          path="/negociacoes/:idNegociacao"
          component={NegociacoesItem}
        />
        <PrivateRoute exact path="/cotacoes" component={Cotacoes} />
        <PrivateRoute path="/cotacoes/:idCotacao" component={CotacoesItem} />

        <PrivateRoute exact path="/gimplus" component={Gimplus} />
        <PrivateRoute exact path="/finalizado" component={Finalizado} />
        <PrivateRoute
          exact
          path="/vendas-promovidas"
          component={VendasPromovidas}
        />
        <PrivateRoute exact path="/meus-enderecos" component={MeusEnderecos} />
        <PrivateRoute exact path="/meus-cartoes" component={MeusCartoes} />
        <PrivateRoute exact path="/impressao" component={Impressao} />
        <PrivateRoute
          exact
          path="/dados-pagamento/:idpedido"
          component={Pedidos}
        />
        <PrivateRoute exact path="*" component={Erro404} />
      </Switch>
      <GlobalStyles></GlobalStyles>
    </AppProvider>
  )
}

export default App
